import React from 'react';
import {Box, Button} from '@mui/material';
import {useTranslation} from 'react-i18next';

interface RowRepositionBarProps {
    /** Put the row back where the design has it. */
    onReset: () => void;
    /** Leave row mode (the moves are already in sceneTransforms). */
    onDone: () => void;
}

/** Desktop row-reposition controls, under the canvas while a row is being
 *  moved: the same reset / approve pair Fill Mode's sticky bar shows. Kept
 *  separate from FloatingImageControlBar, which is bound to the selected IMAGE
 *  input (its reposition gate, zoom and close all read selectedImageData). */
const RowRepositionBar: React.FC<RowRepositionBarProps> = ({onReset, onDone}) => {
    const {t} = useTranslation();
    return (
        <Box
            data-testid="row-reposition-bar"
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                gap: 1.25,
                mt: 1.75,
                px: 1.5,
                py: 1,
                background: '#051726F2',
                border: '1px solid #ffffff40',
                borderRadius: '14px',
            }}
        >
            <Button
                variant="text"
                onClick={() => onReset()}
                data-testid="row-reposition-reset"
                sx={{color: '#ffffffb0', fontSize: '0.8rem', minWidth: 0, textTransform: 'none', textDecoration: 'underline'}}
            >
                {t('editor.fillMode.repositionReset')}
            </Button>
            <Button
                variant="contained"
                disableElevation
                onClick={() => onDone()}
                data-testid="row-reposition-done"
                sx={{
                    borderRadius: '18px',
                    px: 2.5,
                    fontWeight: 700,
                    textTransform: 'none',
                    color: 'white',
                    backgroundColor: '#00E162',
                    '&:hover': {backgroundColor: '#3D9A4A'},
                }}
            >
                {t('editor.fillMode.repositionApprove')}
            </Button>
        </Box>
    );
};

export default RowRepositionBar;
